import { RouterProvider } from 'react-router';
import ProfileContextWrap from './Components/PortfolioContextWrap';
import { router } from './Routes';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

import './App.scss';

const queryClient = new QueryClient();

const App = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <ProfileContextWrap>
        <RouterProvider router={router} />
      </ProfileContextWrap>
    </QueryClientProvider>
  );
};

export default App;
